import { CardContent, Typography} from "@mui/material"
import MyTable, { TableRow } from "../../../components/MyTable";

import { TableHeadRows } from "../../../components/MyTable/TableHead";
import DownloadButtonDocument from "../../my-potal/documents/downloadButtonDocument";
import { CONTRACT_DOCUMENT_SIGNATURE_REQUEST } from "../../../constants/signalRequestConsts";
import { formatDateToTimestamp } from "../../../utils/date";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { InMyChargeEmployeeDocumentsRequestId } from "../../../store/slices/userRequests";


interface TableDocumentsProps {
    loading?: boolean;
    requestId: InMyChargeEmployeeDocumentsRequestId,
    description: string;
    setDescription: (desc: string) => void;
    pageSize: number;
    setPageSize: (page: number) => void;
    page: number;
    setPage: (page: number) => void;
}

const TablePaymentSlips = ({
    requestId, 
    description,
    setDescription,
    pageSize,
    setPageSize,
    page,
    setPage,
    loading,
}: TableDocumentsProps) => {

    const {documents, totalItems} = useSelector((state: RootState) => state.userRequests)[requestId];

    const MyButton = (headRow: TableHeadRows, row: TableRow<string, any>) => {
        return (
            <DownloadButtonDocument
                FirmaTop={row.FirmaTop}
                NroFs={row.NroFS}
                FirmadoFecha={row.FirmadoFecha} 
                IdDocument={row.NroBoletaNomina}
                requestId={CONTRACT_DOCUMENT_SIGNATURE_REQUEST}
                signDisabled={true}
                signButton={false}
            />
        )
    }
    
    const tableHeadRows = [
        {
            label: "Periodo",
            rowKeyName: "Periodo",
            buildOrderValue: (row: string) => {
                const value = row?.split(" ").slice(1, 5).join("")
                return value
            },
            allowOrderAction: true,
        },{
            label: "Número",
            rowKeyName: "NumeroDocumento",
            allowOrderAction: true,
        },{
            label: "Tipo de documento",
            rowKeyName: "TipoDocumento",
            allowOrderAction: true,
        },{
            label: "Fecha de envío",
            rowKeyName: "FechaEnviadoPortal",
            allowOrderAction: true,
        },
        {
            label: "Fecha de firma",
            rowKeyName: "FirmadoFecha",
            allowOrderAction: true,
        },
        {
            label: "",
            rowKeyName: "viewFile",
            customValue: MyButton,
        }
    ,];

    return  (
        <>
        <MyTable
            key="tab-0"
            pageNumber={page}
            itemsPerPage={pageSize}
            totalItems={totalItems}
            totalPages={totalItems / pageSize}
            searchInputString={description}
            onChangePageNumber={setPage}
            onChangeItemsPerPage={setPageSize}
            onChangeSearchInputString={setDescription}
            hiddenSearchInput={false}
            tableHeadRows={tableHeadRows}
            // hiddenFilterOptions={hiddenFilterOptions}
            tableRows={documents}
            loading={loading || false}
            cardComponent={{
                cardContent: (row) => {
                    return (
                        <CardContent style={{padding: "0 1rem 1rem 1rem"}}>
                            <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem">
                                {row.Descripcion} 
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Tipo: {" "}
                                <Typography variant="body2" component="span">
                                    {row.TipoDocumento}
                                </Typography>
                            </Typography>
                            {/* <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                #: {" "}
                                <Typography variant="body2" component="span">
                                    {row.NumeroDocumento}
                                </Typography>
                            </Typography> */}
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Periodo: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Periodo}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Tipo Doc.: {" "}
                                <Typography variant="body2" component="span">
                                    {row.TipoDocumento}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha Envío: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FechaEnviadoPortal) as any}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha Firma: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FirmadoFecha) as any}
                                </Typography>
                            </Typography>
                            {MyButton({} as any, row)}
                        </CardContent>
                    );
                },
                numberOfCards: 1,
                changeViewOptionHidden: true,
            }}
            tableOptionsBar={{
                useDrawer: true,
            }}
            hiddenBottomPaginator={true}
        />
        </>
    )
}

export default TablePaymentSlips